/** @format */
import React from 'react'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { _$, Card } from 'kpc-react'
import MonitorAlarmingCard from 'src/containers/MonitorAlarming'
const MonitorAlarming = () => {
  return (
    <div>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('正在告警') }]} />
      <Card>
        <MonitorAlarmingCard />
      </Card>
    </div>
  )
}
export default MonitorAlarming
